module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/3l1YlU/tc-custom/9781528955850.jpg?1705687860569",
      "alt": "This image is the cover for the book The Final Heist"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Final Heist\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Four old men had spent most of their adult life in prison following many failed attempts to rob financial institutions. Now aged late 70s and early 80s, they are released from a long jail term to take up residence in a warden-controlled, local-authority owned block of self-contained apartments. Other residents are a strange mixture. The local diminutive vicar relaunches the campanology group. The bell-ringing group of gays drives the bats from the belfry, along with other animals. The four decide that life in Bogwash is not to their liking and plan the last heist, just to get convicted and return to a world they understand. Dressed as four gorillas, wearing flashy Bermuda shorts and high-visibility jackets, they plan on robbing a small post office.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      William Pullar\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("William Pullar is the pseudonym of a long-retired, Scottish-born national newspaper journalist. He covered many high-profile court cases and took part in several major investigations leading to convictions.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0